
// File: frontend/src/modules/trading/dispatch_order/services/tradingDispatchOrderService.js

import axiosClient from "../../../../api/axiosClient";

const BASE_URL = "/api/trading/dispatch-orders";

const tradingDispatchOrderService = {
  // Dispatch Order list
  getDispatchOrders(params = {}) {
    return axiosClient.get(`${BASE_URL}/`, { params });
  },

  // Dispatch Order details
  getDispatchOrder(dispatchOrderId) {
    return axiosClient.get(`${BASE_URL}/${dispatchOrderId}`);
  },

  // Eligible approved Sales Orders
  getEligibleSalesOrders(params = {}) {
    return axiosClient.get(`${BASE_URL}/eligible-sales-orders`, {
      params,
    });
  },

  // Sales Order items available for dispatch
  getDispatchableSalesOrderItems(salesOrderId) {
    return axiosClient.get(
      `${BASE_URL}/sales-orders/${salesOrderId}/dispatchable-items`
    );
  },

  // Create Dispatch Order
  createDispatchOrder(payload) {
    return axiosClient.post(`${BASE_URL}/`, payload);
  },

  // Update a draft Dispatch Order
  updateDispatchOrder(dispatchOrderId, payload) {
    return axiosClient.put(`${BASE_URL}/${dispatchOrderId}`, payload);
  },

  // Submit for approval
  submitForApproval(dispatchOrderId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${dispatchOrderId}/submit-for-approval`,
      payload
    );
  },

  // Approve Dispatch Order
  approveDispatchOrder(dispatchOrderId) {
    return axiosClient.post(`${BASE_URL}/${dispatchOrderId}/approve`, {});
  },

  // Reject Dispatch Order
  rejectDispatchOrder(dispatchOrderId, rejectionReason) {
    return axiosClient.post(`${BASE_URL}/${dispatchOrderId}/reject`, {
      rejection_reason: rejectionReason,
    });
  },
};

export default tradingDispatchOrderService;
